export const ScrollUp = () => {
	document.querySelector("body").scrollTo(0, 0);
};
